import { ChevronsDownUp, ChevronsUpDown } from "lucide-react"

interface EliminatedDividerProps {
  eliminatedCount: number
  showEliminated?: boolean | undefined
  onToggleEliminated?: (() => void) | undefined
  interactive?: boolean | undefined // If false, shows static "ELIMINATED" label
}

export function EliminatedDivider({
  eliminatedCount,
  showEliminated = true,
  onToggleEliminated,
  interactive = true,
}: EliminatedDividerProps) {
  if (eliminatedCount === 0) return null

  return (
    <div className="relative">
      <div className="flex items-center">
        <div className="flex-1 h-px bg-white/10" />
        {interactive && onToggleEliminated ? (
          <button
            onClick={(e) => {
              e.stopPropagation()
              onToggleEliminated()
            }}
            className="px-[0.65rem] py-1.5 text-[0.735rem] text-white/60 hover:text-white/80 transition-colors tracking-[.055rem] flex items-center gap-1"
            type="button"
          >
            {eliminatedCount} ELIMINATED
            {showEliminated ? <ChevronsDownUp className="w-3 h-3" /> : <ChevronsUpDown className="w-3 h-3" />}
          </button>
        ) : (
          <span className="px-[0.65rem] py-1.5 text-[0.735rem] text-white/60 tracking-[.055rem]">
            {eliminatedCount} ELIMINATED
          </span>
        )}
        <div className="flex-1 h-px bg-white/10" />
      </div>
    </div>
  )
}
